import request from '@/utils/http.js'

// 搜索栏目
export function searchCate(data) {
    return request({
        url: '/api/searchCate',
        method: 'get',
        params: data
    })
}
// 发展历程
export function timeline() {
    return request({
        url: '/api/article/timeline',
        method: 'get',
    })
}


// 搜索文章
export function search(data) {
    return request({
        url: '/api/search',
        method: 'get',
        params: data
    })
}


// 获取配置信息
export function config() {
    return request({
        url: '/api/config',
        method: 'get'
    })
}


// 留言
export function feedback(data) {
    return request({
        url: '/api/feedback',
        method: 'post',
        data:data
    })
}

// 获取栏目
export function cate() {
    return request({
        url: '/api/cate',
        method: 'get'
    })
}

// 首页
export function getIndex() {
    return request({
        url: '/api/index',
        method: 'get'
    })
}

// 文章详情
export function getRead(data) {
    return request({
        url: '/api/article/read',
        method: 'get',
        params: data
    })
}


// 文章列表
export function getList(data) {
    return request({
        url: '/api/article/list',
        method: 'get',
        params: data
    })
}